import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { CalendarClock, Phone, MapPin, CheckCircle2 } from "lucide-react";

const STATUSES = ["new", "confirmed", "picked_up", "completed", "cancelled"];

const Bookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/bookings").then((r) => { setBookings(r.data); setLoading(false); });
  useEffect(() => { load(); }, []);

  const update = async (id, s) => {
    await api.patch(`/bookings/${id}`, { status: s });
    toast.success(`Marked as ${s}`);
    load();
  };

  return (
    <div className="space-y-6" data-testid="bookings-page">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900" style={{ fontFamily: 'Poppins' }}>Pickup Requests</h1>
        <p className="text-sm text-slate-500">All bookings from your website.</p>
      </div>
      {loading ? <div className="h-40 bg-slate-100 rounded-xl animate-pulse"/> :
       bookings.length === 0 ? (
        <div className="qw-dash-card p-12 text-center text-slate-400"><CalendarClock size={36} className="mx-auto mb-3 text-slate-300"/>No pickup requests yet.</div>
       ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {bookings.map((b) => (
            <div key={b.id} className="qw-dash-card p-6" data-testid={`booking-${b.id}`}>
              <div className="flex justify-between items-start mb-3">
                <div>
                  <div className="font-semibold text-lg text-slate-900" style={{ fontFamily: 'Poppins' }}>{b.name}</div>
                  <div className="text-sm text-slate-600">{b.service_type}</div>
                </div>
                <span className={b.status === "new" ? "qw-badge-orange" : b.status === "completed" ? "qw-badge-green" : "qw-badge-blue"}>{b.status}</span>
              </div>
              <div className="text-sm space-y-1 mb-4">
                <div className="flex items-center gap-2 text-slate-600"><Phone size={14}/><a href={`tel:${b.mobile}`} className="text-blue-600 hover:underline">{b.mobile}</a></div>
                <div className="flex items-start gap-2 text-slate-600"><MapPin size={14} className="mt-0.5"/>{b.address}</div>
                <div className="flex items-center gap-2 text-slate-600"><CalendarClock size={14}/>{b.pickup_date} · {b.pickup_time}</div>
                {b.instructions && <div className="text-xs text-slate-500 border-l-2 border-slate-200 pl-2 mt-2">{b.instructions}</div>}
              </div>
              <div className="flex flex-wrap gap-2">
                {STATUSES.filter((s) => s !== b.status).map((s) => (
                  <button key={s} onClick={() => update(b.id, s)} className="text-xs px-3 py-1.5 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-700" data-testid={`booking-${b.id}-${s}`}>Mark {s}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Bookings;
